import ParcelexApi from '../../services/parcelex';

export default {
  getOnboarding({ transactionId, returnTransaction = true, isMobile }) {
    const query = new URLSearchParams({
      transactionId,
      returnTransaction,
      returnTransactionAndCheckout: returnTransaction,
      isMobile,
    }).toString();

    return ParcelexApi.get(`onboarding/v2/?${query}`);
  },
  getOnboardingLink({ onboardingId }) {
    return ParcelexApi.get(`onboarding/v2/${onboardingId}/onboarding-link`);
  },
  sendImage({ onboardingId, step, base64Img, extraData }) {
    return ParcelexApi
      .post(`onboarding/v2/${onboardingId}/${step.toLowerCase()}/send`, {
        base64Img,
        ...extraData,
      });
  },
  resendConfirmation({ onboardingId, isMobile, type }) {
    return ParcelexApi.post(`onboarding/v2/${onboardingId}/confirmation/resend`, {
      isMobile,
      type,
    });
  },
  sendConfirmation({ onboardingId, securityCode }) {
    return ParcelexApi.post(`onboarding/v2/${onboardingId}/confirmation/send`, {
      securityCode,
    });
  },
  sendContractConfirmation({ onboardingId }) {
    return ParcelexApi.post(`onboarding/v2/${onboardingId}/contract`, {
      onboardingId,
    });
  },
  getInsuranceOptions(onbordingId) {
    return ParcelexApi.get(`insurance/${onbordingId}`);
  },
  sendInsuranceConfirmation(onbordingId, hasInsurance) {
    return ParcelexApi.post(`onboarding/v2/${onbordingId}/insurance`, { hasInsurance });
  },
  downloadPDFFromS3(filename) {
    return ParcelexApi
      .get(`onboarding/v2/s3/pdf/${filename}`,
        { responseType: 'blob' });
  },
};
